import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { COLORS, convertToButton, useIsDoubleClick } from '../../../../../../../utils';
import { IButtonCategory, IFontTypes, ITextAlignment } from '../../../../../../r3f/r3f-components/component-data-structure';
import CSS from './DefaultBtnGrid.scss';
export const BASIC_BUTTON_TEXT = 'Abc';
export const sharedDefaultProps = {
    id: '',
    renderOrder: 1,
    text: BASIC_BUTTON_TEXT,
    fontFamily: IFontTypes.Roboto400,
    fontSize: 0.11,
    scale: [0.37, 0.13, 0],
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    textAlignment: ITextAlignment.center,
};
export const btnSharedStyle = {
    width: '100px',
    height: '36px',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    backgroundColor: COLORS.nebula,
};
const frameStyle = {
    width: '100px',
    height: '36px',
    border: '2px solid ' + COLORS.nebula,
    backgroundColor: 'transparent',
    color: COLORS.nebula,
};
export const slightlyRoundedStyle = {
    borderRadius: '6px',
};
const defaultBtnInfo = [
    {
        style: {
            ...btnSharedStyle,
            ...slightlyRoundedStyle,
        },
        borderRadius: 0.35,
        borderWidth: 0,
        borderRgba: [82, 118, 247, 1],
        fontRgba: [255, 255, 255, 1],
        color: [[82, 118, 247, 1]],
        curvature: 0,
        category: IButtonCategory.text,
        ...sharedDefaultProps,
    },
    {
        style: {
            ...btnSharedStyle,
            ...slightlyRoundedStyle,
            ...frameStyle,
        },
        borderRadius: 0.35,
        borderWidth: 0.01,
        borderRgba: [82, 118, 247, 1],
        fontRgba: [82, 118, 247, 1],
        color: [[255, 255, 255, 0]],
        curvature: 0,
        category: IButtonCategory.text,
        ...sharedDefaultProps,
    }
];
const DefaultBtnGrid = ({ onPointerDown, onDoubleClick }) => {
    const isDoubleClick = useIsDoubleClick();
    const btnInfo = useMemo(() => defaultBtnInfo.map((btnDft) => {
        return { ...btnDft, id: crypto.randomUUID() };
    }), []);
    const DefaultElements = btnInfo.map((opt) => {
        return (_jsx("div", { id: opt.id, style: opt.style, onPointerDown: (e) => {
                if (isDoubleClick())
                    onDoubleClick?.(convertToButton(opt), e);
                else
                    onPointerDown?.(convertToButton(opt), e);
            }, children: opt.text }, opt.id));
    });
    return _jsx("div", { className: CSS.Grid, children: DefaultElements });
};
export default DefaultBtnGrid;
